import { render, staticRenderFns } from "./YInput.vue?vue&type=template&id=2d012e70&scoped=true"
import script from "./YInput.vue?vue&type=script&lang=js"
export * from "./YInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d012e70",
  null
  
)

export default component.exports